/**
 * Abre la tabla de índices en un modal, sin salir de la calculadora.
 *
 * El botón es un enlace normal a /pages/indices-de-saponificacion. Aquí sólo
 * se intercepta el clic: se descarga esa página y se trasplanta su tabla al
 * modal. Si algo falla —red, marcado distinto— no se bloquea nada: se deja
 * seguir la navegación y el usuario acaba en la página, que es el destino real.
 *
 * Se respeta cmd/ctrl/click central para abrir en pestaña nueva.
 */
(function () {
  var cta = document.querySelector("[data-ma-sapcta-abrir]");
  var modal = document.querySelector("[data-ma-sapmodal]");
  if (!cta || !modal) return;

  var cuerpo = modal.querySelector("[data-ma-sapmodal-cuerpo]");
  var cargado = false;
  var ultimoFoco = null;

  function abrir() {
    ultimoFoco = document.activeElement;
    modal.removeAttribute("hidden");
    document.documentElement.style.overflow = "hidden";
    var cerrar = modal.querySelector(".ma-sapmodal__cerrar");
    if (cerrar) cerrar.focus();
  }

  function cerrar() {
    modal.setAttribute("hidden", "");
    document.documentElement.style.overflow = "";
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  function cargar(url) {
    if (cargado) return Promise.resolve(true);
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var tabla = doc.querySelector(".ma-sap");
        if (!tabla) throw new Error("sin tabla");
        cuerpo.innerHTML = "";
        var copia = document.importNode(tabla, true);
        // En su página, el título de la tabla es el H1. Aquí ya hay uno (el de
        // la calculadora) y el modal trae su propio encabezado, así que el
        // clonado baja a H2 para no dejar dos H1 en el documento.
        var titulo = copia.querySelector("h1");
        if (titulo) {
          var h2 = document.createElement("h2");
          h2.className = titulo.className;
          h2.textContent = titulo.textContent;
          titulo.parentNode.replaceChild(h2, titulo);
        }
        cuerpo.appendChild(copia);
        cargado = true;
        return true;
      });
  }

  cta.addEventListener("click", function (e) {
    // Dejar pasar los atajos de "abrir en otra pestaña".
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;

    var url = cta.getAttribute("href");
    if (!url) return;

    e.preventDefault();
    abrir();
    cargar(url).catch(function () {
      // Sin modal utilizable, ir a la página de verdad.
      window.location.href = url;
    });
  });

  modal.addEventListener("click", function (e) {
    if (e.target.closest("[data-ma-sapmodal-cerrar]")) cerrar();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !modal.hasAttribute("hidden")) cerrar();
  });
})();
